import React from "react"
import PropTypes from "prop-types"

import Button from "../atoms/Button"
import Header from "../molecules/Header"
import Grid from "../organisms/Grid"
import Icon from "../../images/x-thin-md.svg"

import styles from "./Modal.module.css"

class Modal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      show: this.props.show,
    }

    this.hideModal = this.hideModal.bind(this)
    this.bodyRef = React.createRef()
  }

  hideModal() {
    this.props.handleClose()
  }

  scrollToTop() {
    this.props.scrollTopCallback()

    this.bodyRef.current.scrollTo(0, 0)
  }

  render() {
    this.props.scrollTop && this.scrollToTop()
    const containerClasses = `${styles.container} ${
      this.props.show ? styles.containerShow : styles.containerHide
    }`

    return (
      <div
        className={containerClasses}
        aria-hidden={this.props.show ? null : "true"}
        tabIndex={this.props.show ? 1 : -1}
      >
        <div className={styles.bg} onClick={this.hideModal} />
        <article className={styles.body} ref={this.bodyRef}>
          <div className={styles.close}>
            <Button kind="icon" icon={<Icon />} onClick={this.hideModal} />
          </div>
          <Grid type="rows">
            <Header title={this.props.title} subtitle={this.props.subtitle} />
            <div>{this.props.children}</div>
          </Grid>
        </article>
      </div>
    )
  }
}

Modal.defaultProps = {
  show: false,
  scrollTop: false,
  handleClose: () => {},
  scrollTopCallback: () => {},
}

Modal.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  scrollTop: PropTypes.bool,
  scrollTopCallback: PropTypes.func,
}

export default Modal
